import React from 'react';
import { useTranslation } from 'utils/i18n';
import translations from './translations';
import './AboutUsVisionSection.css';

/**
 * AboutUsVisionSection Component
 * Vision section component for AboutUs page
 * Extracted from pending_about/pending_AboutUs
 */
const AboutUsVisionSection = ({ pageTranslations }) => {
  const { language } = useTranslation();
  
  // Get component-specific translations
  // eslint-disable-next-line no-unused-vars
  const t = (key, defaultValue = '') => {
    const componentTranslations = translations[language] || translations.en;
    const value = key.split('.').reduce((obj, k) => obj?.[k], componentTranslations);
    // Fallback to page translations if not found in component translations
    if (!value || value === key) {
      const pageValue = key.split('.').reduce((obj, k) => obj?.[k], pageTranslations?.vision || {});
      return pageValue || defaultValue || key;
    }
    return value || defaultValue || key;
  };

  // Use page translations directly if component translations not available
  const pageT = (key, defaultValue = '') => {
    if (!pageTranslations) return defaultValue;
    const value = key.split('.').reduce((obj, k) => obj?.[k], pageTranslations.vision || {});
    return value || defaultValue || key;
  };

  return (
    <section className="content-section">
      <h2>{pageT('heading', 'Our Vision')}</h2>
      <p>
        {pageT('description', 'Our vision is to offer a platform on which SME companies can manage all of their SaaS needs in a reliable and cost-efficient way and find trustworthy partners to work with.')}
      </p>
      <div className="vision-grid">
        <div className="vision-card">
          <h3>{pageT('forCustomers.heading', 'For Customers')}</h3>
          <p>
            {pageT('forCustomers.description', 'Our self-service platform enables businesses to purchase and deploy chatbot solutions independently. With minimal technical knowledge required, you can acquire a Besper bot and implement it directly on your website through our streamlined integration process.')}
          </p>
        </div>
        <div className="vision-card">
          <h3>{pageT('forPartners.heading', 'For Partners')}</h3>
          <p>
            {pageT('forPartners.description', 'Partners can resell our products to their customers and manage both their customers and product portfolio through our comprehensive platform. Our platform provides centralized management capabilities for all partner operations.')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUsVisionSection;


